import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { JPMAM_ORDER_BASE_PATH } from '../../../../../../../../../features/vendor/jpmam/order/jpmam-order-routing';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jpm/order/_order')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'jpmam-order-list',
        label: 'J.P. Morgan',
        to: JPMAM_ORDER_BASE_PATH,
      }),
    }) satisfies AggregateBreadcrumb,
});
